import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import RoleAwareLink from '../../common/RoleAwareLink';
import ServicesList from './servicesList/servicesList';
import SearchHeader from '../headers/searchHeader';
import ResetServicesOrderButton from './containers/ResetServicesOrderButton';

const Services = ({
  services,
  link,
  shouldShowCategoriesLink,
  shouldShowAddServiceButton,
  exportCsv,
  updateServiceList,
}) => (
  <div>
    <SearchHeader heading="Services" type="service" className="u-pr" />
    <div className="c-wrapper">
      <div className={`o-flexbox${!shouldShowCategoriesLink ? ' o-flexbox--justify-end' : ''}`}>
        <div className="o-flexbox">
          <RoleAwareLink
            display-if={shouldShowCategoriesLink}
            to="/services/categories"
            className="c-btn c-btn--medium u-mr-"
          >
            Categories
          </RoleAwareLink>
          <ResetServicesOrderButton />
        </div>
        <div className="o-flexbox">
          <button className="c-btn c-btn--medium" onClick={exportCsv}>
            Export to csv
          </button>
          <Link
            to={link}
            className="c-btn c-btn--medium u-ml-"
            display-if={shouldShowAddServiceButton}
          >
            Add Service
          </Link>
        </div>
      </div>

      <ServicesList
        services={services}
        onSortChange={updateServiceList}
      />
    </div>
  </div>
);

Services.propTypes = {
  services: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  link: PropTypes.string.isRequired,
  updateServiceList: PropTypes.func.isRequired,
  exportCsv: PropTypes.func.isRequired,
  shouldShowCategoriesLink: PropTypes.bool.isRequired,
  shouldShowAddServiceButton: PropTypes.bool.isRequired,
};

export default Services;
